import AOS from 'aos';

import {load} from '../vendor/theme-scripts/theme-sections';
import loadScript from '../util/loader';

// $.ajaxSetup({ cache: false });

// document.documentElement.style.setProperty('--scrollbar-width', `${getScrollbarWidth()}px`);

document.addEventListener('DOMContentLoaded', function () {
  // Load all registered sections on the page.
  load('*');

  const showAnimations = document.body.dataset.animations === 'true';
  if (showAnimations) {
    AOS.init({
      once: true,
      offset: 50,
      duration: 600,
      startEvent: 'load',
    });
  }

  //   PaloAlto.initFocusVisibility();
  //   PaloAlto.Drawer.init();

  //   document.addEventListener('theme:resize:width', PaloAlto.setMainSpacing);

  //   // We need to check if hash tag is different than #! because slate.a11y throws an error in this case
  //   const hash = window.location.hash;
  //   const elementId = hash.substr(1, hash.length);
  //   const element = document.getElementById(elementId);

  //   if (element !== null) {
  //     slate.a11y.pageLinkFocus($(window.location.hash));
  //   }

  //   const skipLink = document.querySelector('.in-page-link');
  //   if (skipLink) {
  //     skipLink.addEventListener('click', function(evt) {
  //       slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  //     });
  //   }

  // Safari smoothscroll polyfill
  const hasNativeSmoothScroll = 'scrollBehavior' in document.documentElement.style;

  if (!hasNativeSmoothScroll) {
    loadScript({url: theme.assets.smoothscroll});
  }
});

// PaloAlto.updateHash = function(hash) {
//   window.location.hash = '#' + hash;
//   $('#' + hash).attr('tabindex', -1).focus();
// };

// document.addEventListener('shopify:section:unload', () => {
//   PaloAlto.Drawer.destroy();
// });
// document.addEventListener('shopify:section:load', () => {
//   window.dispatchEvent(new Event('resize'), {bubbles: true});
//   preventOverflow(document);
//   PaloAlto.Drawer.init();
// });

// if (typeof theme.settings.newHash !== 'undefined') {
//   PaloAlto.updateHash(theme.settings.newHash);
// }

// window.addEventListener('load', () => {
//   preventOverflow(document);
//   loadingAnimation();
// });
